import { Box, Typography, Button as MuiButton, Grow } from '@mui/material';
import { styled } from '@mui/material/styles';

const SuccessForm = ({
  onSubmit,
  loading,
  title = '',
  description = <>Welcome! Let’s build and share expertise together.</>,
}) => {
  return (
    <Grow in style={{ transformOrigin: 'top center' }}>
      <Container>
        <Title>{title}</Title>
        <Description>{description}</Description>

        <Button fullWidth variant="contained" onClick={onSubmit} disabled={loading}>
          {loading ? 'Logging In...' : 'Login'}
        </Button>
      </Container>
    </Grow>
  );
};

const Container = styled(Box, { label: 'Container' })(({ theme }) => ({
  maxWidth: 500,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(2),
}));

const Title = styled(Typography, { label: 'Title' })(({ theme }) => ({
  textAlign: 'center',
  fontSize: 32,
  fontWeight: 700,
  color: theme.palette.custom.mirage,
  marginBottom: 8,
  [theme.breakpoints.down('md')]: {
    fontSize: 24,
  },
}));

const Description = styled(Typography, { label: 'Description' })({
  fontSize: 18,
  textAlign: 'center',
  margin: '16px 0',
});

const Button = styled(MuiButton, { label: 'Button' })({
  borderRadius: 8,
  height: 56,
});

export default SuccessForm;
